import { Card, CardActions, CardContent, List, ListItem, ListItemIcon, ListItemText, Skeleton, Typography } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';

export function SalesOfferProductSelectionSkeleton() {
	const rows = Array.from(Array(1).keys())

	return <>
		<Typography
			variant="h5"
			component="div"
			className="mt-4 mb-3 mb-md-0">
			<Skeleton animation="wave" width={150} />
		</Typography>
		<Row>
			<Col>
				<div className='d-flex justify-content-end mb-3'>
					<Skeleton animation="wave" width={150} height={50} />
				</div>
			</Col>
		</Row>
		<Row>
			{rows.map((row, index) => (
				<Col sm={6} md={6} lg={6} xxl={4} className='col-xxxl-3' key={index}>
					<Card
						variant="elevation"
						className="mb-4">
						<CardContent sx={{ height: '175px' }}>
							<List dense disablePadding>
								<ListItem disableGutters alignItems="flex-start">
									<ListItemIcon>
										<Skeleton animation="wave" variant="rectangular" width={40} height={40} className='me-3' />
									</ListItemIcon>
									<ListItemText
										primary={<span className='MuiTypography-body2'><Skeleton animation="wave" width={150} /></span>}
										secondary={<span className='MuiTypography-body3'><Skeleton animation="wave" width={150} /></span>} />
								</ListItem>
								<ListItem disableGutters>
									<ListItemText
										primary={<span className='MuiTypography-body4'><Skeleton animation="wave" width={150} /></span>} />
								</ListItem>
							</List>
						</CardContent>
						<CardActions className='d-flex justify-content-between'>
							<Skeleton animation="wave" width={100} height={50} />
							<Skeleton animation="wave" width={100} height={50} />
						</CardActions>
					</Card>
				</Col>
			))}
		</Row>
	</>;
}

export default SalesOfferProductSelectionSkeleton;
